<template>
  <div class="home">
    <section
      v-if="carouselStatus === 'success' && carouselItems.length > 0"
      class="carousel-section"
    >
      <div class="premium-block">
        <div class="premium-content">
          <div class="premium-text">
            <h2 class="premium-title">
              Более 500 европейских фабрик. Один надежный партнер.
            </h2>
          </div>
        </div>
      </div>

    <div class="hero-carousel-wrapper">
      <Carousel
  :value="carouselItems"
  :numVisible="1"
  :numScroll="1"
  :autoplayInterval="5000"
  :circular="true"
  :showIndicators="true"
  :showNavigators="carouselItems.length > 1"
  class="hero-carousel"
>
  <template #item="{ data }">
<div
  class="carousel-slide"
  :class="{ 'is-clickable': data.link }"
  @click="data.link && navigateTo(data.link)"
>
      <img
        :src="data.imageUrl"
        :alt="data.title ?? ''"
        class="carousel-image"
      />
      <div class="slide-overlay"></div>
      <div
        v-if="data.title?.trim() || data.subtitle || (data.link && data.buttonText)"
        class="slide-content-wrapper"
        :class="[
          'position-' + (data.titlePosition || 'center'),
          'align-' + (data.textAlign || 'center')
        ]"
      >
        <div class="slide-content">
          <h2
            v-if="data.title?.trim()"
            class="slide-title"
            :style="{
              fontSize: (data.titleSize || 42) + 'px',
              color: data.titleColor || '#FFFFFF'
            }"
          >
            {{ data.title }}
          </h2>
          <p
            v-if="data.subtitle"
            class="slide-subtitle"
            :style="{
              fontSize: (data.subtitleSize || 16) + 'px',
              color: data.subtitleColor || '#E0E0E0'
            }"
          >
            {{ data.subtitle }}
          </p>
          <Button
            v-if="data.link && data.buttonText"
            :label="data.buttonText"
            class="slide-btn"
            @click="navigateTo(data.link)"
          />
        </div>
      </div>
    </div>
  </template>
</Carousel>

</div>

    </section>

    <section
      v-else-if="carouselStatus === 'success' && carouselItems.length === 0"
      class="hero"
    >
      <div class="hero-inner">
        <div class="logo">
          <span class="in">IN</span>
          <span class="red">RED</span>
          <span class="box">BOX</span>
        </div>
        <h1>Добро пожаловать!</h1>
        <p class="hero-description">
          Место, где стиль встречается с удобством. IN RED BOX помогает находить
          решения для пространства, в котором хочется жить, работать и
          вдохновляться.
        </p>
        <div class="hero-buttons">
          <router-link to="/products" custom v-slot="{ navigate }">
            <Button
              label="Открыть каталог"
              icon="pi pi-arrow-right"
              iconPos="right"
              class="btn-primary"
              @click="navigate"
            />
          </router-link>
          <router-link
            v-if="!authStore.isAuthenticated"
            to="/auth"
            custom
            v-slot="{ navigate }"
          >
            <Button
              label="Войти"
              icon="pi pi-sign-in"
              class="btn-secondary"
              @click="navigate"
            />
          </router-link>
          <router-link v-else to="/cabinet" custom v-slot="{ navigate }">
            <Button
              label="Перейти в кабинет"
              icon="pi pi-user"
              class="btn-secondary"
              @click="navigate"
            />
          </router-link>
        </div>
        <div class="hero-features">
          <div class="feature">
            <i class="pi pi-box"></i>
            <div>
              <span class="feature-title">Каталог</span>
              <span class="feature-text">Удобный просмотр товаров</span>
            </div>
          </div>
          <div class="feature">
            <i class="pi pi-shopping-cart"></i>
            <div>
              <span class="feature-title">Проекты</span>
              <span class="feature-text">Быстрое добавление в проекты</span>
            </div>
          </div>
          <div class="feature">
            <i class="pi pi-user"></i>
            <div>
              <span class="feature-title">Личный кабинет</span>
              <span class="feature-text">Управление профилем</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="categories-carousel-section">
      <div class="container">
        <div class="categories-header">
          <h2 class="categories-title">Категории</h2>
          <router-link to="/products" class="categories-link">
            Все категории →
          </router-link>
        </div>

        <div class="categories-slider-wrapper">
          <button
            class="slider-nav prev"
            @click="scrollCategories(-1)"
            :disabled="categoriesScroll === 0"
          >
            <i class="pi pi-chevron-left"></i>
          </button>

          <div class="categories-slider" ref="categoriesSlider">
            <div
              class="categories-track"
              :style="{ transform: `translateX(-${categoriesScroll}px)` }"
            >
              <CategoryCircleCard
                v-for="(category, idx) in categories"
                :key="category.id"
                :name="category.name"
                :image-url="category.imageUrl"
                :highlighted="idx === 0"
                @select="goToCategory(category.id)"
              />
            </div>
          </div>

          <button
            class="slider-nav next"
            @click="scrollCategories(1)"
            :disabled="categoriesScroll >= maxCategoriesScroll"
          >
            <i class="pi pi-chevron-right"></i>
          </button>
        </div>
      </div>
    </section>

    <section v-if="weeklyItems.length > 0" class="weekly-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">Еженедельный отбор</h2>
          <div class="section-line"></div>
        </div>
        <div class="weekly-grid">
          <div
            v-for="item in displayedWeeklyItems"
            :key="item.id"
            class="weekly-card"
            @click="goToProduct(item.link || `/products/${item.productId}`)"
          >
            <div class="weekly-image-wrapper">
              <img
                :src="item.imageUrl"
                :alt="item.title"
                class="weekly-image"
              />
            </div>
            <div class="weekly-info">
              <h3 class="weekly-title">{{ item.title }}</h3>
              <p v-if="item.subtitle" class="weekly-subtitle">
                {{ item.subtitle }}
              </p>
              <div class="weekly-action">
                <span>Подробнее</span>
                <i class="pi pi-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="weeklyItems.length > visibleWeeklyCount"
          class="weekly-footer"
        >
          <Button
            label="Показать больше"
            icon="pi pi-arrow-right"
            iconPos="right"
            class="weekly-more-btn"
            @click="showMoreWeekly"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, nextTick } from "vue";
import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";
import Button from "primevue/button";
import Carousel from "primevue/carousel";
import { useAuthStore } from "@/modules/auth/store/auth.store";
import { getActiveWeeklyItems } from "@/modules/admin/homepage/api/weekly.service";
import { getAllCategories } from "@/modules/admin/categories/api/categories.service";
import { usePublicCarouselStore } from "@/shared/stores/public-carousel.store";
import CategoryCircleCard from "@/shared/ui/CategoryCircleCard.vue";

const router = useRouter();
const authStore = useAuthStore();
const carouselStore = usePublicCarouselStore();
const { items: carouselItems, status: carouselStatus } = storeToRefs(carouselStore);

const weeklyItems = ref([]);
const categories = ref([]);
const visibleWeeklyCount = ref(8);
const categoriesSlider = ref(null);
const categoriesScroll = ref(0);
const maxCategoriesScroll = ref(0);
const itemWidth = 136;

const displayedWeeklyItems = computed(() => {
  return weeklyItems.value.slice(0, visibleWeeklyCount.value);
});

onMounted(async () => {
  await carouselStore.ensureLoaded().catch((error) => {
    console.error("Ошибка загрузки карусели:", error);
  });
  await loadCategories();
  await loadWeeklySelection();
  await nextTick();
  updateMaxScroll();
  window.addEventListener("resize", updateMaxScroll);
});

async function loadWeeklySelection() {
  try {
    weeklyItems.value = await getActiveWeeklyItems();
  } catch (error) {
    console.error("Ошибка загрузки Weekly Selection:", error);
  }
}

async function loadCategories() {
  try {
    categories.value = await getAllCategories();
  } catch (error) {
    console.error("Ошибка загрузки категорий:", error);
  }
}

function updateMaxScroll() {
  if (categoriesSlider.value) {
    const containerWidth = categoriesSlider.value.clientWidth;
    const totalWidth = categories.value.length * itemWidth;
    maxCategoriesScroll.value = Math.max(0, totalWidth - containerWidth);
  }
}

function scrollCategories(direction) {
  const newScroll = categoriesScroll.value + direction * (itemWidth * 4);
  if (newScroll >= 0 && newScroll <= maxCategoriesScroll.value) {
    categoriesScroll.value = newScroll;
  }
}

function showMoreWeekly() {
  visibleWeeklyCount.value += 8;
}

function navigateTo(link) {
  if (link.startsWith("http")) {
    window.open(link, "_blank");
  } else if (link) {
    router.push(link);
  }
}

function goToProduct(link) {
  if (!authStore.isAuthenticated) {
    router.push('/auth')
    return
  }
  if (link) {
    if (link.startsWith("http")) {
      window.open(link, "_blank");
    } else {
      router.push(link);
    }
  }
}

function goToCategory(id) {
  if (!authStore.isAuthenticated) {
    router.push('/auth')
    return
  }
  router.push({
    path: "/products",
    query: { categoryId: id },
  });
}

</script>

<style scoped>
.home {
  min-height: 100vh;
  background: #ffffff;
}

.carousel-section {
  padding: 0;
  background: #ffffff;
  overflow: hidden;
}

.premium-block {
  padding: 38px 24px 34px;
  background: #ffffff;
}

.premium-content {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.premium-text {
  max-width: 1200px;
  margin: 0 auto;
}

.premium-title {
  font-size: 28px;
  font-weight: 400;
  letter-spacing: 0.5px;
  color: #111;
  margin: 0;
  line-height: 1.25;
  text-transform: none;
}

.hero-carousel-wrapper {
  position: relative;
  width: 100vw;
  margin-left: 50%;
  transform: translateX(-50%);
  overflow: hidden;
}

.hero-carousel {
  width: 100vw;
  margin-left: 50%;
  transform: translateX(-50%);
  overflow: hidden;
  position: relative;
}

:deep(.hero-carousel .p-carousel-content) {
  position: relative;
}

:deep(.hero-carousel .p-carousel-container) {
  position: relative;
  width: 100%;
}

:deep(.hero-carousel .p-carousel-items-container) {
  width: 100%;
}

:deep(.hero-carousel .p-carousel-items-content) {
  width: 100%;
}

:deep(.hero-carousel .p-carousel-item) {
  width: 100%;
}

.carousel-slide {
  position: relative;
  height: 620px;
  overflow: hidden;
  background: #111;
}

.carousel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.slide-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    rgba(0, 0, 0, 0.28) 0%,
    rgba(0, 0, 0, 0.52) 100%
  );
}

.slide-content-wrapper {
  position: absolute;
  inset: 0;
  display: flex;
  z-index: 2;
}

.position-top {
  align-items: flex-start;
  padding-top: 80px;
}

.position-center {
  align-items: center;
}

.position-bottom {
  align-items: flex-end;
  padding-bottom: 80px;
}

.align-left {
  justify-content: flex-start;
  text-align: left;
}

.align-center {
  justify-content: center;
  text-align: center;
}

.align-right {
  justify-content: flex-end;
  text-align: right;
}

.slide-content {
  max-width: 620px;
  padding: 0 40px;
  width: 100%;
}

.slide-title {
  font-weight: 700;
  margin: 0 0 16px;
  line-height: 1.2;
  letter-spacing: -0.02em;
  text-shadow: 0 2px 5px rgba(0, 0, 0, 0.35);
}

.slide-subtitle {
  margin: 0 0 24px;
  line-height: 1.5;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
}

.slide-btn {
  background: rgba(0, 0, 0, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.75) !important;
  color: white !important;
  border-radius: 40px !important;
  padding: 10px 28px !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  transition: all 0.2s ease !important;
}

.slide-btn:hover {
  background: white !important;
  color: #111 !important;
  transform: translateY(-2px);
}

:deep(.hero-carousel .p-carousel-prev),
:deep(.hero-carousel .p-carousel-next) {
  position: absolute !important;
  top: 50% !important;
  z-index: 50 !important;
  transform: translateY(-50%) !important;
  background: rgba(0, 0, 0, 0.35) !important;
  border-radius: 50% !important;
  width: 48px !important;
  height: 48px !important;
  color: white !important;
  transition: all 0.2s ease !important;
  border: 1px solid rgba(255, 255, 255, 0.45) !important;
}

:deep(.hero-carousel .p-carousel-prev:hover),
:deep(.hero-carousel .p-carousel-next:hover) {
  background: rgba(0, 0, 0, 0.65) !important;
}

:deep(.hero-carousel .p-carousel-prev) {
  left: 32px !important;
}

:deep(.hero-carousel .p-carousel-next) {
  right: 32px !important;
}

:deep(.hero-carousel .p-carousel-indicators) {
  position: absolute;
  bottom: 24px;
  left: 0;
  right: 0;
  z-index: 50;
  gap: 10px;
}

:deep(.hero-carousel .p-carousel-indicator button) {
  background: rgba(255, 255, 255, 0.55) !important;
  width: 9px !important;
  height: 9px !important;
  border-radius: 50% !important;
  transition: all 0.2s ease !important;
}

:deep(.hero-carousel .p-carousel-indicator.p-highlight button) {
  background: white !important;
  width: 26px !important;
  border-radius: 12px !important;
}

.hero-nav {
  position: absolute;
  top: 50%;
  z-index: 60;
  transform: translateY(-50%);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.55);
  background: rgba(0, 0, 0, 0.35);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.hero-nav-prev {
  left: 32px;
}

.hero-nav-next {
  right: 32px;
}

.hero-nav:hover {
  background: rgba(0, 0, 0, 0.65);
}

.hero {
  min-height: calc(100vh - 80px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 60px 24px;
}

.hero-inner {
  max-width: 900px;
  width: 100%;
  text-align: center;
  background: white;
  border-radius: 32px;
  padding: 56px 48px;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.06);
}

.hero-inner .logo {
  width: 140px;
  margin: 0 auto 32px;
  background: #c41217;
  padding: 14px 12px 10px;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.in,
.red,
.box {
  display: block;
  font-weight: 800;
  line-height: 0.9;
  letter-spacing: -0.04em;
  font-size: 32px;
}

.in {
  color: #111;
}

.red,
.box {
  color: #fff;
}

.hero-inner h1 {
  font-size: 40px;
  font-weight: 700;
  color: #111;
  margin: 0 0 20px;
  letter-spacing: -0.02em;
}

.hero-description {
  font-size: 16px;
  line-height: 1.7;
  color: #555;
  max-width: 600px;
  margin: 0 auto 32px;
}

.hero-buttons {
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 48px;
}

.btn-primary,
.btn-secondary {
  border-radius: 40px !important;
  padding: 10px 28px !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  transition: all 0.2s ease !important;
}

.btn-primary {
  background: #111 !important;
  border-color: #111 !important;
  color: white !important;
}

.btn-primary:hover {
  background: #333 !important;
  transform: translateY(-2px);
}

.btn-secondary {
  background: transparent !important;
  border: 1px solid #ddd !important;
  color: #333 !important;
}

.btn-secondary:hover {
  border-color: #c41217 !important;
  color: #c41217 !important;
  transform: translateY(-2px);
}

.hero-features {
  display: flex;
  justify-content: center;
  gap: 32px;
  flex-wrap: wrap;
  border-top: 1px solid #eee;
  padding-top: 32px;
}

.feature {
  display: flex;
  align-items: center;
  gap: 12px;
}

.feature i {
  font-size: 28px;
  color: #c41217;
}

.feature div {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.feature-title {
  font-size: 15px;
  font-weight: 600;
  color: #111;
}

.feature-text {
  font-size: 12px;
  color: #888;
}

.categories-carousel-section {
  padding: 56px 24px 60px;
  background: #ffffff;
}

.categories-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

.categories-title {
  font-size: 24px;
  font-weight: 600;
  color: #111;
  margin: 0;
}

.categories-link {
  font-size: 13px;
  color: #c41217;
  text-decoration: none;
  transition: opacity 0.2s;
}

.categories-link:hover {
  opacity: 0.7;
}

.categories-slider-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  max-width: 1280px;
  margin: 0 auto;
}

.categories-slider {
  flex: 1;
  overflow: hidden;
  scroll-behavior: smooth;
}

.categories-track {
  display: flex;
  gap: 24px;
  transition: transform 0.3s ease;
  will-change: transform;
}

.slider-nav {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.slider-nav:hover:not(:disabled) {
  background: #f5f5f5;
  border-color: #c41217;
}

.slider-nav:disabled {
  opacity: 0;
  visibility: hidden;
  cursor: not-allowed;
}

.slider-nav i {
  font-size: 14px;
  color: #333;
}

.container {
  max-width: 1280px;
  margin: 0 auto;
}

.weekly-section {
  padding: 60px 24px;
  background: #f8f9fc;
}

.section-header {
  margin-bottom: 40px;
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

.section-title {
  font-size: 28px;
  font-weight: 600;
  color: #111;
  margin: 0 0 12px;
  letter-spacing: -0.02em;
}

.section-line {
  width: 60px;
  height: 3px;
  background: #c41217;
  border-radius: 3px;
}

.weekly-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  max-width: 1280px;
  margin: 0 auto;
}

.weekly-card {
  cursor: pointer;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  transition: all 0.25s ease;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  border: 1px solid #ececec;
  display: flex;
  flex-direction: column;
}

.weekly-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
}

.weekly-image-wrapper {
  aspect-ratio: 1 / 1;
  overflow: hidden;
  background: #f5f5f5;
}

.weekly-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.weekly-card:hover .weekly-image {
  transform: scale(1.05);
}

.weekly-info {
  padding: 18px;
  min-height: 135px;
  display: flex;
  flex-direction: column;
}

.weekly-title {
  font-size: 16px;
  font-weight: 600;
  color: #111;
  margin: 0 0 8px;
  line-height: 1.35;
}

.weekly-subtitle {
  font-size: 13px;
  color: #777;
  margin: 0;
  line-height: 1.45;
  flex: 1;
}

.weekly-action {
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 500;
  color: #c41217;
}

.weekly-action i {
  font-size: 12px;
  transition: transform 0.2s ease;
}

.weekly-card:hover .weekly-action i {
  transform: translateX(3px);
}

.weekly-footer {
  text-align: center;
  margin-top: 48px;
}

.weekly-more-btn {
  background: transparent !important;
  border: 2px solid #c41217 !important;
  color: #c41217 !important;
  border-radius: 44px !important;
  padding: 10px 32px !important;
  font-weight: 500 !important;
  transition: all 0.2s !important;
}

.weekly-more-btn:hover {
  background: #c41217 !important;
  color: white !important;
}

@media (max-width: 1200px) {
  .weekly-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .premium-title {
    font-size: 24px;
  }
}

@media (max-width: 1024px) {
  .carousel-slide {
    height: 520px;
  }
}

@media (max-width: 900px) {
  .weekly-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .premium-title {
    font-size: 22px;
  }
}

@media (max-width: 768px) {
  .premium-block {
    padding: 28px 20px 24px;
  }

  .carousel-slide {
    height: 420px;
  }

  .slide-content {
    padding: 0 24px;
  }

  .slide-title {
    font-size: 28px !important;
  }

  .slide-subtitle {
    font-size: 14px !important;
  }

  .hero-inner {
    padding: 40px 24px;
  }

  .hero-inner h1 {
    font-size: 32px;
  }

  .hero-description {
    font-size: 14px;
  }

  .hero-features {
    gap: 20px;
  }

  .feature {
    flex-direction: column;
    text-align: center;
  }

  .feature div {
    align-items: center;
    text-align: center;
  }

  .position-top {
    padding-top: 50px;
  }

  .position-bottom {
    padding-bottom: 50px;
  }

  .categories-header {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }

  .categories-title {
    font-size: 20px;
  }

  .section-title {
    font-size: 24px;
  }

  .weekly-section {
    padding: 40px 20px;
  }

  .categories-track {
    gap: 16px;
  }

  .premium-title {
    font-size: 20px;
  }

  :deep(.hero-carousel .p-carousel-prev),
  :deep(.hero-carousel .p-carousel-next) {
    width: 40px !important;
    height: 40px !important;
  }

  :deep(.hero-carousel .p-carousel-prev) {
    left: 16px !important;
  }

  :deep(.hero-carousel .p-carousel-next) {
    right: 16px !important;
  }
}

@media (max-width: 600px) {
  .weekly-grid {
    grid-template-columns: 1fr;
  }

  .categories-track {
    gap: 12px;
  }
}

@media (max-width: 480px) {
  .carousel-slide {
    height: 340px;
  }

  .slide-title {
    font-size: 24px !important;
  }

  .slide-subtitle {
    font-size: 12px !important;
    margin-bottom: 16px;
  }

  .slide-btn {
    padding: 6px 20px !important;
    font-size: 12px !important;
  }

  .hero-buttons {
    flex-direction: column;
  }

  .btn-primary,
  .btn-secondary {
    width: 100%;
  }

  .weekly-title {
    font-size: 15px;
  }
}
</style>
